import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { PerformanceRules, PerformanceRulesVariables } from './__generated__/PerformanceRules';

export const PERFORMANCE_RULES_QUERY = gql`
  query PerformanceRulesQuery($search: String, $publisherId: ID!) {
    performanceRules(publisherId: $publisherId, search: $search) {
      edges {
        node {
          id
          name
          level
          evaluationSpec
          status
          createdBy
          triggered
          executionSpec
          campaign {
            name
            id
          }
          createdAt
          updatedAt
          triggeredAt
          articleIds
          ruleActivities {
            id
            activity
            details
            createdBy
            createdAt
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;

export const usePerformanceRulesLazyQuery = () => {
  return useLazyQuery<PerformanceRules, PerformanceRulesVariables>(PERFORMANCE_RULES_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
